import { useEffect, useState } from "react";
import { api } from "@/api";
import { ArrowLeft, Calendar, Clock, TrendingUp, FileText } from "lucide-react";
import ReportCard from "@/components/ReportCard";

export default function UserHistoryPage({ userId, onBack }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get(`/reports/user/${userId}`);
      setData(data);
    } finally { setLoading(false); }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [userId]);

  if (loading) return <div className="loading-block">Yükleniyor…</div>;
  if (!data) return <div className="empty-state">Veri bulunamadı</div>;

  return (
    <>
      <div className="page-heading compact-heading">
        <div>
          <button className="text-button" onClick={onBack} data-testid="back-to-users">
            <ArrowLeft size={14}/> Kullanıcılar
          </button>
          <p className="eyebrow" style={{ marginTop: 8 }}>Rapor geçmişi</p>
          <h1>{data.user.name}</h1>
          <p className="subheading">{data.user.position || "—"} · {data.user.email}</p>
        </div>
      </div>

      <div className="metrics-grid" data-testid="user-stats">
        <div className="metric">
          <div className="metric-icon green"><Calendar size={18}/></div>
          <div className="metric-copy"><span>Son 7 gün</span><strong>{data.stats.days_last_7} / 7 gün</strong></div>
        </div>
        <div className="metric">
          <div className="metric-icon amber"><TrendingUp size={18}/></div>
          <div className="metric-copy"><span>Son 30 gün</span><strong>{data.stats.days_last_30} / 30 gün</strong></div>
        </div>
        <div className="metric">
          <div className="metric-icon"><Clock size={18}/></div>
          <div className="metric-copy"><span>Son 30 gün çalışma</span><strong>{data.stats.hours_last_30} saat</strong></div>
        </div>
      </div>

      <div style={{ marginTop: 24 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 14 }}>
          <FileText size={16} style={{ color: "#10b981" }}/>
          <h2 style={{ margin: 0, fontSize: 18 }}>Raporlar</h2>
          <span className="cell-muted" style={{ marginLeft: 4 }}>({(data.reports || []).length})</span>
        </div>
        {(data.reports || []).length === 0 ? (
          <div className="empty-state">
            <FileText size={28}/>
            <h3>Henüz rapor yok</h3>
          </div>
        ) : (
          <div className="reports-grid" data-testid="user-reports-list">
            {data.reports.map((r) => <ReportCard key={r.id} report={r} onChanged={load} />)}
          </div>
        )}
      </div>
    </>
  );
}
